<template>
    <div class="sidebar-panel">
        <kl-draw-zone-sidebar-header v-if="showTitle" :title="title" tag-style="h5"/>
        <vl-sidebar-content class="kl-sidebar__section kl-sidebar__section-smaller">
            <vl-title tag-name="h3" tag-style="h6" class="vl-sidebar-header__title kl-sidebar__section__fillrow">
                {{importTitle}}
            </vl-title>
            <vl-button type="button" mod-small mod-tertiary @click="onCancel">Annuleren</vl-button>
        </vl-sidebar-content>

        <vl-sidebar-content class="kl-sidebar__section-import-warning kl-sidebar__section-no-border-top">
            <vl-title tag-style="h6" class="kl-sidebar__text18 kl-sidebar__margin-bottom5">
                U gebruikt <vl-link :href="lambert72HelpUrl" target="_blank">Lambert 72</vl-link>-coördinaten
            </vl-title>
            <div>KLIP werkt sinds 2025 met <vl-link :href="lambert2008HelpUrl" target="_blank">Lambert 2008</vl-link>.</div>
            <div>Geen probleem, wij converteren uw bestand naar Lambert 2008 en dit nog tot eind 2028.</div>
            <div>Bij vragen, contacteer de <vl-link :href="helpdeskHelpUrl" target="_blank">Helpdesk</vl-link>.</div>
            <br/>
            <vl-button type="button" mod-small mod-block @click="onContinue">Ga verder met deze zone(s)</vl-button>
        </vl-sidebar-content>

        <kl-draw-zone-sidebar-filler/>
    </div>
</template>

<script lang="ts">

import {computed, defineComponent} from 'vue';
import KlDrawZoneSidebarHeader
    from '@/app/shared/components/kl-draw-zone-map/components/kl-draw-zone-sidebar-header.vue';
import KlDrawZoneSidebarFiller
    from '@/app/shared/components/kl-draw-zone-map/components/kl-draw-zone-sidebar-filler.vue';

export default defineComponent({
    name: 'KlDrawZoneSidebarImportLambertWarning',
    emits: ['cancel', 'continue'],
    components: {
        KlDrawZoneSidebarHeader,
        KlDrawZoneSidebarFiller,
    },
    props: {
        title: { type: String, required: true },
        showTitle: { type: Boolean, default: true },
        modEnableMultiZones: { type: Boolean, default: false },
        lambert72HelpUrl: { type: String, default: 'https://epsg.io/31370' },
        lambert2008HelpUrl: { type: String, default: 'https://epsg.io/3812' },
        helpdeskHelpUrl: { type: String, default: import.meta.env.VITE_LINKS_HELPDESK_HELP },
    },
    setup(props, { emit }) {

        const onCancel = () => {
            emit('cancel');
        }

        const onContinue = () => {
            emit('continue');
        }

        const importTitle = computed(() => {
           if (props.modEnableMultiZones) {
               return 'Importeer zone(s)';
           }
           return 'Importeer zone';
        });

        return {
            importTitle,
            onCancel,
            onContinue,
        }
    }
})

</script>
